import * as React from 'react';

import PropTypes from 'prop-types';

import ActionIcon from 'bundles/internal-ui/components/icon/ActionIcon';

class ActionCell extends React.Component {
  static propTypes = {
    row: PropTypes.object,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string,
        onClick: PropTypes.func,
        tooltip: PropTypes.string,
        style: PropTypes.string,
      })
    ),
  };

  render() {
    return (
      <td className="action">
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'actions' does not exist on type 'Readonl... Remove this comment to see the full error message */}
        {this.props.actions.map(
          (
            action: $TSFixMe // @ts-expect-error ts-migrate(2339) FIXME: Property 'row' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
          ) => !this.props.row.disableAction && <ActionIcon row={this.props.row} action={action} key={action.icon} />
        )}
      </td>
    );
  }
}

export default ActionCell;
